module.exports = __webpack_public_path__ + "img/default.02b2b4de.svg";